import * as types from '../mutation-types'
import { restApiRequest, getErrorMessage } from './ajax'

const campaignReport = {
  namespaced: true,
  state: {
    campaignReport: {}
  },
  getters: {
    dailyReport: state => (state.campaignReport ? state.campaignReport.dailyReport : [])
  },
  mutations: {
    [types.RECEIVE_SETREPORT](state, campaignReport) {
      state.campaignReport = campaignReport
    }
  },
  actions: {
    /**
     * フィルタ条件を取得する
     * @param {*} params
     */
    getCampaignReport: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        restApiRequest(baseURL, `/api/campaign/cpm/report/${params.privateCode}/${params.advertiserId}/${params.campaignId}/${params.targetDateFrom}/${params.targetDateTo}/`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              const report = pluckData(result)
              commit(types.RECEIVE_SETREPORT, report)
              resolve(report)
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_SETREPORT, undefined)
    }
  }
}

function pluckData(response) {
  return response.data
}

export default campaignReport
